export default "__VITE_ASSET__DHd5H8W0__"